import { EnvironmentProviders } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { Blue } from './themes/blue';
import { Noir } from './themes/noir';

export const providePrimengConfiguration = (
  options: { preset: typeof Blue | typeof Noir } = { preset: Blue },
): EnvironmentProviders => {
  return providePrimeNG({
    overlayAppendTo: 'body',
    translation: {
      accept: 'Tak',
      addRule: 'Dodaj regułę',
      after: 'Po',
      am: 'am',
      apply: 'Zastosuj',
      aria: {
        cancelEdit: 'Anuluj edycję',
        close: 'Zamknij',
        collapseRow: 'Wiersz zwinięty',
        editRow: 'Edytuj wiersz',
        expandRow: 'Wiersz rozwinięty',
        falseLabel: 'Fałsz',
        filterConstraint: 'Ograniczenie filtra',
        filterOperator: 'Operator filtra',
        firstPageLabel: 'Pierwsza strona',
        gridView: 'Widok siatki',
        hideFilterMenu: 'Ukryj menu filtrów',
        jumpToPageDropdownLabel: 'Przejdź do rozwijanej strony',
        jumpToPageInputLabel: 'Przejdź do strony',
        lastPageLabel: 'Ostatnia strona',
        listView: 'Widok listy',
        moveAllToSource: 'Przenieś wszystko do źródła',
        moveAllToTarget: 'Przenieś wszystko do celu',
        moveBottom: 'Przenieś na dół',
        moveDown: 'Przenieś w dół',
        moveToSource: 'Przenieś do źródła',
        moveToTarget: 'Przenieś do celu',
        moveTop: 'Przenieś na górę',
        moveUp: 'Przenieś w górę',
        navigation: 'Nawigacja',
        next: 'Następny',
        nextPageLabel: 'Następna strona',
        nullLabel: 'Nie wybrano',
        pageLabel: '{page}',
        previous: 'Poprzedni',
        prevPageLabel: 'Poprzednia strona',
        rotateLeft: 'Obróć w lewo',
        rotateRight: 'Obróć w prawo',
        rowsPerPageLabel: 'Wierszy na stronę',
        saveEdit: 'Zapisz edycję',
        scrollTop: 'Przewiń na górę',
        selectAll: 'Wszystkie elementy wybrane',
        selectRow: 'Wiersz wybrany',
        showFilterMenu: 'Pokaż menu filtrów',
        slide: 'Slajd',
        slideNumber: '{slideNumber}',
        star: '1 gwiazdka',
        stars: '{star} gwiazdki',
        trueLabel: 'Prawda',
        unselectAll: 'Wszystkie elementy odznaczone',
        unselectRow: 'Wiersz odznaczony',
        zoomImage: 'Powiększ obraz',
        zoomIn: 'Powiększ',
        zoomOut: 'Pomniejsz',
      },
      before: 'Przed',
      cancel: 'Anuluj',
      choose: 'Wybierz',
      chooseDate: 'Wybierz datę',
      chooseMonth: 'Wybierz miesiąc',
      chooseYear: 'Wybierz rok',
      clear: 'Wyczyść',
      contains: 'Zawiera',
      dateAfter: 'Data po',
      dateBefore: 'Data przed',
      dateFormat: 'dd/mm/yy',
      dateIs: 'Data to',
      dateIsNot: 'Data to nie',
      dayNames: [
        'Niedziela',
        'Poniedziałek',
        'Wtorek',
        'Środa',
        'Czwartek',
        'Piątek',
        'Sobota',
      ],
      dayNamesMin: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb'],
      dayNamesShort: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
      emptyFilterMessage: 'Nie znaleziono wyników',
      emptyMessage: 'Brak dostępnych opcji',
      emptySearchMessage: 'Nie znaleziono wyników',
      emptySelectionMessage: 'Brak wybranego elementu',
      endsWith: 'Kończy się na',
      equals: 'Równa się',
      fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      firstDayOfWeek: 0,
      gt: 'Większe niż',
      gte: 'Większe lub równe',
      is: 'Jest',
      isNot: 'Nie jest',
      lt: 'Mniejsze niż',
      lte: 'Mniejsze lub równe',
      matchAll: 'Pasuje do wszystkich',
      matchAny: 'Pasuje do dowolnego',
      medium: 'Średnie',
      monthNames: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      monthNamesShort: [
        'Sty',
        'Lut',
        'Mar',
        'Kwi',
        'Maj',
        'Cze',
        'Lip',
        'Sie',
        'Wrz',
        'Paź',
        'Lis',
        'Gru',
      ],
      nextDecade: 'Następna dekada',
      nextHour: 'Następna godzina',
      nextMinute: 'Następna minuta',
      nextMonth: 'Następny miesiąc',
      nextSecond: 'Następna sekunda',
      nextYear: 'Następny rok',
      noFilter: 'Brak filtra',
      notContains: 'Nie zawiera',
      notEquals: 'Nie równa się',
      passwordPrompt: 'Wprowadź hasło',
      pending: 'Oczekujące',
      pm: 'pm',
      prevDecade: 'Poprzednia dekada',
      prevHour: 'Poprzednia godzina',
      prevMinute: 'Poprzednia minuta',
      prevMonth: 'Poprzedni miesiąc',
      prevSecond: 'Poprzednia sekunda',
      prevYear: 'Poprzedni rok',
      reject: 'Nie',
      removeRule: 'Usuń regułę',
      searchMessage: '{0} wyników dostępnych',
      selectionMessage: '{0} elementów wybranych',
      startsWith: 'Zaczyna się od',
      strong: 'Silne',
      today: 'Dzisiaj',
      upload: 'Prześlij',
      weak: 'Słabe',
      weekHeader: 'Tydz',
    },
    theme: {
      preset: options.preset,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primeng',
          order: 'tailwind-base, primeng, tailwind-utilities',
        },
      },
    },
  });
};
